import React from "react";

import WelcomeContainer from "components/WelcomeContainer";
import Camera from "components/Camera";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Cookie from "universal-cookie";
import Modal from "components/Modal";
import Countdown from "react-countdown";

const cookie = new Cookie();

export default function WelcomeGap(props) {
  const general = useSelector((state) => state.general);
  const history = useHistory();

  const TOTAL_TIME = 25 * 60 * 1000;

  const getRemaining = () => {
    const startTime = cookie.get("start_time_bod3_gap");
    if (!startTime) return TOTAL_TIME;
    const elapsed = Date.now() - parseInt(startTime);
    return Math.max(0, TOTAL_TIME - elapsed);
  };

  const clickAgree = () => {
    history.push("/bod3-gap/assestment");
  };

  const handleTimeUp = () => {
    history.push("/bod3-gap/assestment");
  };

  return (
    <div>
      <Modal token={props.token} profile={props.profile} />

      {general.on_cam && <Camera profile={props.profile} />}
      <WelcomeContainer
        key="bod3-case-b"
        ln="id"
        btnText="Mulai"
        clickAgree={clickAgree}
        welcomeMessage="Anda akan menjalani Situational Judgement Test (SJT) untuk posisi BOD-3 GAP Analysis. Perhatikan waktu pengerjaan Anda. Anda dapat sewaktu-waktu membuka kembali gambaran umum perusahaan dan petunjuk pengisian ini dengan mengklik di bagian kanan atas sebelah waktu."
        timerComponent={
          <div
            style={{
              backgroundColor: "#fff3cd",
              border: "1px solid #ffc107",
              borderRadius: 8,
              padding: "10px 16px",
              display: "flex",
              alignItems: "center",
              gap: 10,
              width: "50%",
              marginBottom: 8,
            }}
          >
            <span style={{ fontSize: 18 }}>⏱</span>
            <div
              style={{
                display: "flex",
                alignItems: "start",
                flexDirection: "column",
                justifyContent: "",
              }}
            >
              <span style={{ margin: 0, fontSize: 12, color: "#666" }}>
                Waktu pengerjaan sudah berjalan
              </span>
              <Countdown
                date={Date.now() + getRemaining()}
                onComplete={handleTimeUp}
                renderer={({ hours, minutes, seconds }) => (
                  <span
                    style={{
                      fontSize: 20,
                      fontWeight: "bold",
                      color: "#e53935",
                    }}
                  >
                    {hours > 0 ? `${String(hours).padStart(2, "0")}:` : ""}
                    {String(minutes).padStart(2, "0")}:
                    {String(seconds).padStart(2, "0")}
                  </span>
                )}
              />
            </div>
          </div>
        }
      >
        <div className="welcome-mobile">
          <h3 style={{ color: "#00abbd" }}>
            Gambaran umum perusahaan dan Petunjuk pengisian
          </h3>

          <p>
            PT Nusantara Consumer Goods (NCG) merupakan perusahaan lokal di
            industri kecantikan dan perawatan pribadi yang berperan penting
            dalam menyediakan produk Skincare, Hair Care, dan Personal Care
            untuk konsumen Indonesia. Dalam menghadapi persaingan pasar yang
            ketat, perubahan tren konsumen yang cepat, serta tuntutan inovasi
            dan efisiensi operasional yang berkelanjutan, perusahaan secara
            konsisten mendorong peningkatan kinerja, kualitas eksekusi, serta
            penguatan kapabilitas tim di semua lini agar tetap tumbuh dan
            kompetitif.
          </p>

          <p>
            Anda saat ini berperan sebagai <b>Manager (BOD-3)</b> yang memegang
            peran penting dalam menerjemahkan arahan dari Pimpinan/ Kepala
            Departemen ke dalam tindakan operasional dan taktis di tingkat unit
            kerja. Pada posisi ini, Anda diharapkan mampu mengelola tim secara
            efektif, mengkoordinasikan lintas fungsi dalam unit, menyelesaikan
            masalah operasional secara proaktif, serta berkontribusi pada
            pencapaian target Departemen dengan baik.
          </p>

          <p>
            Dalam tes ini, Anda akan dihadapkan pada sejumlah situasi kerja
            realistis yang mencerminkan tantangan manajerial di lingkungan PT
            Nusantara Consumer Goods (NCG). Setiap situasi disertai dengan
            beberapa alternatif tindakan yang seluruhnya mungkin dilakukan,
            namun memiliki tingkat efektivitas yang berbeda.
          </p>

          <h4 style={{ marginTop: 20, color: "#78000F" }}>Tugas Anda:</h4>
          <p>
            Pilih satu tindakan yang menurut Anda PALING TEPAT sesuai dengan
            masing-masing situasi.
          </p>
          <p>
            Pilihan terbaik adalah tindakan yang paling mencerminkan efektivitas
            manajerial, ketepatan dalam mengelola tim dan proses, serta
            keselarasan dengan tujuan Unit dan Departemen, bukan sekadar
            tindakan yang paling mudah atau paling aman.
          </p>

          <h4 style={{ marginTop: 20, color: "#78000F" }}>Petunjuk Penting:</h4>
          <ul style={{ textAlign: "left", lineHeight: "1.8" }}>
            <li>
              Pertimbangkan dampak keputusan terhadap kinerja tim, koordinasi
              lintas fungsi, serta pencapaian target unit kerja.
            </li>
            <li>
              Tidak ada jawaban benar atau salah secara absolut, namun pilihan
              Anda akan mencerminkan pola pengambilan keputusan dan tingkat
              kompetensi manajerial.
            </li>
          </ul>

          <p style={{ marginTop: 20, fontStyle: "italic" }}>
            Kerjakan setiap kasus secara cermat dan konsisten, seolah-olah Anda
            benar-benar berada pada posisi tersebut di lingkungan kerja PT
            Nusantara Consumer Goods (NCG).
          </p>
        </div>
      </WelcomeContainer>
    </div>
  );
}
